import { render, staticRenderFns } from "./POTable.vue?vue&type=template&id=2c328fcd"
import script from "./POTable.vue?vue&type=script&lang=js"
export * from "./POTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports